/* eslint-disable indent */
import { h } from 'preact';
import * as BaseComp from 'components/bolt/hub/components/heroCarousel/heroCarousel.js';
import Store from 'store/store';

import { cssString } from 'utils/cssString';
import { navigateInternally, splitQueryAndPath, getHeaderHeight } from 'utils/bolt';
import { sortObjectByOrder, accessNested, joinClasses } from 'utils/utils';
import { smoothScrollTo } from 'utils/smoothScroll';
import { getDynamicData } from 'utils/bolt/dynamicData';

import Transition from 'components/core/transition/transition';
import HTML from 'components/core/html/html';
// import HubTextOverlay from 'components/bolt/hub/components/hubTextOverlay/hubTextOverlay';
import Button from 'components/bolt/button/button';
import ArrowDown from 'components/bolt/icons/arrowDown';

import s from 'components/bolt/hub/components/heroCarousel/heroCarousel.sss';

export default class HeroCarousel extends BaseComp.default {

	constructor(props) {
		super(props);
		this.scrollToNext = this.scrollToNext.bind(this);
		this.triggerBreadcrumbClick = this.triggerBreadcrumbClick.bind(this);
	}

	async componentDidMount() {
		super.componentDidMount?.();

		const { appData } = Store.get();
		if (appData?.options?.cmsManaged) {
			const activePage = Store.get().activePage;
			switch (activePage) {
				case 'filmmakersStrategies':
					await this.loadCustomData(await getDynamicData('filmmakers-strategies'));
					break;
				case 'homeMIU':
					await this.loadCustomData(await getDynamicData('landing'));
					break;
				case 'utd':
					await this.loadCustomData(await getDynamicData('utd'));
					break;
				case 'belowTheLine':
					await this.loadCustomData(await getDynamicData('below-the-line'));
					break;
				case 'composersInitiative':
					await this.loadCustomData(await getDynamicData('composers-initiative'));
					break;
			}
		}
	}

	async loadCustomData(dynamicData) {
		if (!dynamicData) {
			return;
		}
		const { appData } = Store.get();
		if (!appData?.options?.cmsManaged || !dynamicData) return;

		const logo = dynamicData?.hero?.logo;
		this.heroLogo = {
			src: logo || null,
			enabled: !!logo
		};
		this.slides = dynamicData?.hero?.items?.map((slide) => ({
			title: slide?.title,
			description: slide?.description,
			background: { desktop: slide?.img, mobile: slide?.mobileImg, alt: slide?.alt, bgAlignment: slide?.bgAlignment || 'center' },
			path: slide?.link,
			buttons: slide?.buttons?.map((button) => ({
				label: button?.label,
				link: button?.link,
			}))
		})) || [];
	}

	handleTouchMove(e) {
		this.xMove = e.touches[0].clientX;
		this.yMove = e.touches[0].clientY;

		const verticalSwipe = this.yMove - this.yDown;
		const horizontalSwipe = this.xMove - this.xDown;
		const angle = horizontalSwipe / verticalSwipe;

		const direction = horizontalSwipe > 0 ? -1 : 1;

		if (angle > 1 || angle < -1) {
			e.preventDefault();
			if (!this.direction || direction !== this.direction) {

				Store.emit('CUSTOM_EVENT', {
					category: this.props.id,
					action: 'hero-browse-click'
				});

				this.iterate(direction);
				this.direction = direction;
			}
		}
	}

	trackHeroClick(title, label, link) {
		Store.emit('CUSTOM_EVENT', {
			category: this.props.id,
			action: 'hero-CTA-click',
			label: title + '_' + label + '_' + link,
		});
	}

	triggerBreadcrumbClick(index) {
		//Custom Event before iterate because we only want the event to be triggered if the user is interacting with hero, and the iterate is called in other places.
		Store.emit('CUSTOM_EVENT', {
			category: this.props.id,
			action: 'hero-browse-click'
		});
		this.iterate(null, index);
	}

	scrollToNext(e, time, force) {
		// console.log('scroll to next');
		let scrollContainer = document.getElementById('mainScroll');
		let scrollTo = document.querySelector('.' + s.container).nextElementSibling;
		const isDesktop = accessNested(this.props, 'store.client.isDesktopSize', false);
		const hasSonyHeader = accessNested(this.props, 'store.appData.options.sonyFeatures.sonyHeader', false);
		const scrollOffset = isDesktop ? (hasSonyHeader ? 34 : 0) : (hasSonyHeader ? 58 : getHeaderHeight());

		smoothScrollTo(scrollContainer, scrollTo, time || 300, { offset: scrollOffset, force });
	}

	renderContent(content) {
		const deviceSize = accessNested(this.props, 'client.deviceSize', 'mobile');
		const resolution = deviceSize === 'desktop' ? 'desktop' : 'mobile';
		const logos = sortObjectByOrder(content.logos);
		const { activeIndex } = this.state;
		const slide = this.slides[activeIndex];
		const label = slide?.buttons?.[0]?.label;
		const link = slide?.buttons?.[0]?.link;
		//const isValidBtn = label && link;
		const isValidBtn = slide?.buttons;
		return (
			<div class={s.content}>
				{content.tt && <img class={s.tt} src={content.tt[resolution]} alt={content.tt.alt} />}
				<HTML tag="div" class={s.title} markdown>{content?.title}</HTML>
				{content.tag && (
					<div class={joinClasses(s.tag, 'xlargeB')}>
						<span>{content.tag}</span>
					</div>
				)}
				<HTML tag="div" class={joinClasses(s.description, !content?.title && s.noTitle)} markdown>{content?.description}</HTML>
				{/* possibly remove logo for landing if keeping new image */}
				<div class={s.logos}>
					{logos.map(logo => <img class={s.logo} src={logo.src} alt={logo.alt} />)}
				</div>
				{isValidBtn && slide.buttons && this.renderButtons(slide.buttons, slide, activeIndex)}
			</div>
		);
	}


	renderScrollArrow(copy, isMobile, scrolledALittleBit) {
		return (
			<Button
				class={joinClasses(s.arrowBtn, (isMobile) && s.hide, scrolledALittleBit && s.scrolledALittleBit)}
				trigger={this.scrollToNext}
				style={{ marginBottom: '40px' }}
				key="arrow"
				ariaLabel={copy.accessibilityCopy.$SCROLL_ARROW_ARIA}
			>
				<ArrowDown class={joinClasses(s.arrowDown)} aria-hidden />
			</Button>
		);
	}

	renderBackgrounds() {
		const isDesktopSize = accessNested(this.props, 'client.isDesktopSize', false);
		const resolution = isDesktopSize ? 'desktop' : 'mobile';
		const deviceSize = accessNested(this.props, 'client.deviceSize', 'desktop');

		const DEFAULT_HEIGHTS = {
			largeDesktop: "615px",
			desktop: "60vw",
			smallDesktop: "60vw",
			tablet: "80vw",
			mobile: "80vw",
		};

		const { activeIndex } = this.state;
		const slide = this.slides[activeIndex];
		if (!slide) return;
		const asset = slide.background?.[resolution] || slide.background?.desktop || slide.background?.mobile || '';
		const isVideo = asset.endsWith('.mp4') || asset.endsWith('.webm');
		const backgroundAlignment = slide.background?.bgAlignment || 'center'; // changed because only option were center/left/right
		const backgroundHeight = slide.background?.height || {};
		const height = backgroundHeight?.[deviceSize] ?? DEFAULT_HEIGHTS[deviceSize] ?? "615px";
		const hasGradient = accessNested(this.props, 'appData.heroCarousel.hasGradient', false);

		const textOverlay = slide?.textOverlay?.content;
		const textOverlayId = `slide${activeIndex}`;
		const videoOverlay = slide?.videoOverlay;
		//console.log(backgroundAlignment);

		return (
			<Transition duration={800}>
				<div
					class={joinClasses(s.slide, s[slide.id], slide.dark && s.dark, slide.path && s.clickable)}
					id={`slide${activeIndex}`}
					onClick={e => this.onSlideClick(e, activeIndex, slide.path, slide.title, textOverlay, textOverlayId, videoOverlay)}
					ref={ref => this.slideRefs[`slide${activeIndex}`] = ref}
					style={{ height }}
				>
					{!!asset && !isVideo && <img style={{ objectPosition: backgroundAlignment }} src={asset} alt={slide.background.alt} />}
					{!!asset && isVideo && <video class={s.video} src={asset} autoplay loop muted playsinline />}
					{hasGradient && <div class={s.gradient} />}
					{this.renderContent(slide)}
					{textOverlay && this.renderTextOverlay(textOverlay, textOverlayId)}
				</div>
			</Transition>
		);
	}


	renderBreadcrumbs() {
		let { activeIndex } = this.state;
		const darkCrumbs = this.slides[activeIndex]?.darkCrumbs || this.slides[activeIndex]?.dark;

		if (this.slides.length > 1) {
			return (
				<div class={s.breadcrumbs}>
					{this.slides.map((crumb, index) => {
						let ariaLabel = 'Carousel slide ' + (index + 1) + ' of ' + this.slides.length;
						return (
							<button
								ariaLabel = {ariaLabel}
								class={joinClasses(s.crumb, activeIndex === index && s.active, darkCrumbs && s.dark)}
								onClick={() => this.triggerBreadcrumbClick(index)}
							/>
						);
					})}
				</div>
			);
		}
	}


	renderButton(button, title, slideIndex, index, has3OrMoreButtons) {
		// button.href should be legacy as it's not in the schema
		const link = button.link || button.href || '';
		const textOverlay = button.textOverlay?.content;
		const isMobile = accessNested(this.props, 'client.deviceSize', 'mobile') === 'mobile';

		const colourStyling = Store.get().appData?.styling?.variables;
		const buttonStyle = {
			'--button-background-color': colourStyling?.secondaryColor,
			'--button-text-color': colourStyling?.primaryTextColor,
		};

		if (link.startsWith('http')) {
			return (
				<a
					href={link}
					target="_blank" data-text={button.label}
					class={joinClasses(s.cta, s.watch)}
					onClick={() => this.trackHeroClick(title, button.label, link)}
					style={cssString(buttonStyle)}
				>
					{button.label || button.btnCopy}
				</a>
			);
		}

		return (
			<button
				class={joinClasses(s.cta, s.watch, has3OrMoreButtons && isMobile && s.has3OrMoreButtons)}
				data-text={button.label}
				style={cssString(buttonStyle)}
				onClick={() => {
					const target = button.pageId || button.link;
					let targetTrack = textOverlay ? 'text overlay' : button.videoOverlay?.video ? 'video overlay' : target;
					this.trackHeroClick(title, button.label, targetTrack);
					if (textOverlay) {
						const textOverlayId = `slide${slideIndex}-button${index}`;
						this.toggleTextOverlay(true, textOverlayId);
						return;
					}
					if (button.videoOverlay?.video) {
						return Store.emit('ENABLE_TRAILER_OVERLAY', button.videoOverlay.video);
					}
					if (target) {
						const { path, query } = splitQueryAndPath(target);
						navigateInternally(path, { queryString: query });
					}
				}}
			>
				{button.label}
			</button>
		);
	}

	render() {
		const store = Store.get();
		const { videoOverlay, activeIndex } = this.state;
		const slide = this.slides[activeIndex];
		let appData = store.appData;
		let client = store.client;
		const isMobile = !client.isDesktopSize;
		let copy = appData.copy;

		const activePercentage = accessNested(store, 'activePercentage', 1);

		const scrolledALittleBit = activePercentage <= .8;

		const logoSrc = (this.heroLogo?.enabled && this.heroLogo?.src) || this.props.data?.logo?.src;

		return (
			<div
				class={joinClasses(s.wrapper, (slide?.path || slide?.videoOverlay || slide?.textOverlay) && s.clickable)}
				data-attribute="boltHubPageCarouselHero"
				data-hash-wrapper={this.props.data?.anchor || 'top'}
				id={this.props.data?.anchor || 'top'}
				onTouchStart={this.handleTouchStart}
				onTouchMove={this.handleTouchMove}
				onTouchEnd={this.handleTouchEnd}
			>
				<div class={s.container}>
					{this.renderBackgrounds()}
					{/* <img class={s.logoLarge} src={slide?.backgroundImage} alt="" /> */}
					{this.renderBreadcrumbs()}
					{!!logoSrc && (
						<img class={s.logo} src={logoSrc} alt={this.props.data.logoAlt || 'Universal Logo'} />
					)}
				</div>
				{this.renderScrollArrow(copy, isMobile, scrolledALittleBit)}
			</div>
		);
	}
}
